function readCookie(name) {
    if (typeof document !== 'undefined') {
        //function split cookie for get csrf token
        var nameEQ = name + "=";
        var ca     = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
    }
    return null;
}
const CSRFTOKEN = readCookie('csrftoken'); //get csrftoken

export async function getIfloorplan( id ){
    const config = {
        method: 'GET',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
    }
    const response = await fetch('/api/ifloorplans/'+id, config);
    return await response.json();
}

export async function countView( id ) {
    const config = {
        method: 'PUT',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify({"id": id}),
    }
    const response = await fetch ('/api/count_view/', config);
    return await response.json();
}

export async function submitFeedback(data) {
    let recaptcha_token = '';
    try {
        recaptcha_token = await getRecaptchaToken('feedback');
    } catch (e) {
        console.error('reCAPTCHA error', e);
    }
    const config = {
        method: 'POST',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify({ ...data, recaptcha_token }),
    }
    const response = await fetch('/api/plan_feedback/', config);
    return response;
}

// reCAPTCHA v3 (invisible). Site key is public by design.
const RECAPTCHA_SITE_KEY = '6LeilXQdAAAAACSBqsfuZxCXDoX_WW-qXHE2Ucw6';
let recaptchaScriptPromise = null;

function loadRecaptchaScript() {
    if (typeof window === 'undefined') return Promise.resolve();
    if (window.grecaptcha) return Promise.resolve();
    if (!recaptchaScriptPromise) {
        recaptchaScriptPromise = new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
            s.async = true;
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }
    return recaptchaScriptPromise;
}

export async function getRecaptchaToken(action) {
    await loadRecaptchaScript();
    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('reCAPTCHA timeout')), 8000);
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action })
                .then((token) => { clearTimeout(timeout); resolve(token); })
                .catch((e) => { clearTimeout(timeout); reject(e); });
        });
    });
}
